import type { BoggleBadgeDefinition } from '~/boggle/config/badges/types'
import type { BoggleRunSummaryRatingId } from '~/boggle/config/runSummaryScore'
import type { BoggleBadgeProgressProjection } from '~/boggle/progress/types'

function hasEarnedBadgeRecord(
  countsByRating: Partial<Record<BoggleRunSummaryRatingId, number>>,
  highestRating: BoggleRunSummaryRatingId | null,
) {
  if (highestRating !== null) {
    return true
  }
  return Object.values(countsByRating).some(count => (count ?? 0) > 0)
}

export function isBadgeVisibleInCompendium(
  definition: BoggleBadgeDefinition,
  perBadge: BoggleBadgeProgressProjection['perBadge'],
  revealHiddenLocked: boolean,
): boolean {
  if (definition.lockedReveal !== 'hidden') {
    return true
  }

  if (revealHiddenLocked) {
    return true
  }

  const record = perBadge[definition.id]
  return hasEarnedBadgeRecord(
    record?.countsByRating ?? {},
    record?.highestRating ?? null,
  )
}

export function filterCompendiumBadges(
  badges: readonly BoggleBadgeDefinition[],
  perBadge: BoggleBadgeProgressProjection['perBadge'],
  revealHiddenLocked: boolean,
): readonly BoggleBadgeDefinition[] {
  return badges.filter(definition =>
    isBadgeVisibleInCompendium(definition, perBadge, revealHiddenLocked),
  )
}
